import MuiDivider, { DividerProps } from '@mui/material/Divider';

export function Divider({ sx, ...props }: DividerProps) {
  return <MuiDivider sx={{ my: 3, ...sx }} {...props} />;
}
